











































import { Component, Vue } from "vue-property-decorator"
import { mdiEye, mdiEyeOff } from "@mdi/js"
import Card from "@/components/Card.vue"

@Component({
  components: {
    Card
  }
})
export default class Login extends Vue {
  eyePath = mdiEye
  eyeOffPath = mdiEyeOff
  show = false
  usernameMessages = [] as string[]
  passwordMessages = [] as string[]
  loginForm = {
    email: "",
    password: ""
  }

  login(): void {
    this.$store
      .dispatch("login", this.loginForm)
      .then(() => {
        this.$router.push("/admin")
      })
      .catch(() => {
        this.usernameMessages = [""]
        this.passwordMessages = ["E-mail or password is not correct."]
      })
  }
}
